import React from 'react';
import PageHeader from './PageHeader';
import PageTitle from './PageTitle';

const ProgressFinalThoughts = () => {
	return (
		<div className='Overview'>
			<PageHeader title={'Application'} />

			<div className={'container progress-brief'}>
				<PageTitle title={'Final Thoughts:'} />
				<p>
					Becoming an ideal team player is not something you arrive at. It’s something you keep working on.
					No matter how long you’ve been part of a team or how strong your scores look, there’s always room to grow.
				</p>
				<p>
					The virtues of humility, hunger, and people smarts are like muscles.
					They need regular attention and effort if they’re going to stay strong. And sometimes, one of them needs a little extra work. That’s normal.
				</p>
				<ul>
					<li className={'final-thoughts-list'}>
						If humility is your lowest score, focus on being genuinely others-focused without neglecting your own contributions.
					</li>
					<li className={'final-thoughts-list'}>
						If hunger is where you're struggling, look for ways to take more initiative and follow through consistently.
					</li>
					<li className={'final-thoughts-list'}>
						If people smarts needs attention, work on being more aware of how your words and actions affect the people around you.
					</li>
				</ul>
				<p>
					Don’t try to fix everything overnight. Pick one or two small changes to make, and then stick with them.
					Progress comes from being intentional and consistent.
				</p>
				<p>
					Remember, being an ideal team player is not about perfection.
					It’s about commitment. Keep learning. Keep adjusting. And most of all, keep going.
				</p>
			</div>
		</div>
	);
};

export default ProgressFinalThoughts;
